<section class="registration-dashboard">
    @if (!showDashboard) {
    <div class="registration-header">
        <div class="header-top">
            <div class="header-text">
                <h2 class="title">{{ title }}</h2>
                <p class="subtitle">Select an event to view details</p>
            </div>
        </div>
        <div class="header-controls">
            @if(isLoading){
            <div class="header-controls-skeleton" aria-hidden="true">
                <div class="header-control-skeleton search-skeleton">
                    <app-loading-skeleton [count]="1" height="42px" borderRadius="8px"></app-loading-skeleton>
                </div>
                <div class="header-control-skeleton count-skeleton">
                    <app-loading-skeleton [count]="1" height="18px" width="220px" borderRadius="6px"></app-loading-skeleton>
                </div>
                <div class="header-control-skeleton chips-skeleton">
                    <app-loading-skeleton [count]="1" height="34px" width="96px" borderRadius="999px"></app-loading-skeleton>
                    <app-loading-skeleton [count]="1" height="34px" width="110px" borderRadius="999px"></app-loading-skeleton>
                    <app-loading-skeleton [count]="1" height="34px" width="110px" borderRadius="999px"></app-loading-skeleton>
                </div>
            </div>
            }@else{
            <div class="search-box">
                <input #searchInput type="text" placeholder="Search event(s)..." class="search-input"
                    [value]="searchTerm" (input)="onSearchChange(searchInput.value)">
            </div>
            <p class="events-count" aria-live="polite">Showing {{ displayedEventsCount }} of {{ totalEventsCount }}
                event(s)</p>
            <div class="filter-chips">
                <button type="button" class="filter-chip" [class.active]="isFilterSelected('Active')"
                    (click)="toggleFilter('Active')">
                    Active
                    @if (isFilterSelected('Active')) {
                    <span class="chip-check" aria-hidden="true">✓</span>
                    }
                </button>
                <button type="button" class="filter-chip" [class.upcoming]="isFilterSelected('Upcoming')"
                    (click)="toggleFilter('Upcoming')">
                    Upcoming
                    @if (isFilterSelected('Upcoming')) {
                    <span class="chip-check" aria-hidden="true">✓</span>
                    }
                </button>
                <button type="button" class="filter-chip" [class.completed]="isFilterSelected('Completed')"
                    (click)="toggleFilter('Completed')">
                    Completed
                    @if (isFilterSelected('Completed')) {
                    <span class="chip-check" aria-hidden="true">✓</span>
                    }
                </button>
            </div>
            }
        </div>
    </div>

    <div class="card-grid">
        @if(isLoading){
        <app-loading-skeleton [count]="1" width="100%" height="100%" minHeight="260px"
            borderRadius="8px"></app-loading-skeleton>
        <app-loading-skeleton [count]="1" width="100%" height="100%" minHeight="260px"
            borderRadius="8px"></app-loading-skeleton>
        <app-loading-skeleton [count]="1" width="100%" height="100%" minHeight="260px"
            borderRadius="8px"></app-loading-skeleton>
        <app-loading-skeleton [count]="1" width="100%" height="100%" minHeight="260px"
            borderRadius="8px"></app-loading-skeleton>
        }@else{
        @for (card of filteredCards; track card.event_id || $index) {
        <div type="button" class="header-card-new" [class.active]="card.status === 'Active'"
            [class.upcoming]="card.status === 'Upcoming'" [class.completed]="card.status === 'Completed'"
            (click)="openEvent(card)">
            <div class="card-top-section-new">
                <div class="first-column">
                    <span class="card-title">{{ card.event_name }}</span>
                    <div class="activity-status" [class.active]="card.status === 'Active'"
                        [class.upcoming]="card.status === 'Upcoming'" [class.completed]="card.status === 'Completed'">
                        {{card.status}}
                    </div>
                </div>
                <div class="second-column">
                    <div class="card-date-row">
                        <span class="date-label">
                            <i class="fa-regular fa-calendar date-icon" aria-hidden="true"></i>
                            @if(card.status === 'Upcoming') {
                            <span class="date-label">Registration Opens On:</span>
                            <span class="date-value">{{ card.start_date }}</span>
                            } @else if(card.status === 'Active') {
                            <span class="date-label">

                                <span>Registration Started On:</span>
                            </span>
                            <span class="date-value">{{ card.start_date }}</span>
                            } @else if(card.status === 'Completed') {
                            <span class="date-label">Registration Closed</span>
                            }
                        </span>
                    </div>
                </div>
            </div>
            <div class="card-bottom-section">
                <div class="card-registered-row">
                    <div class="first-column">
                        <span class="registered-count">{{ card.total_venues | number }}</span>
                        <span class="registered-label">
                            <i class="fa-solid fa-location-dot stat-icon" aria-hidden="true"></i>
                            <span>Locations</span>
                        </span>
                    </div>
                    <div class="second-column">
                        <span class="registered-count">{{ card.total_registered_count | number }}</span>
                        <span class="registered-label">
                            <i class="fa-solid fa-user-group" aria-hidden="true"></i>
                            <span>Registrations</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        }
        }
    </div>

    } @else {
    <div class="event-wrapper">
        <ng-container *ngComponentOutlet="eventTabMainComponent;inputs: eventTabInputs"></ng-container>
    </div>
    }
</section>